import PropTypes from 'prop-types';
import React from 'react';
import {
  cCard,
  cCardBody,
  cCardFooter,
} from 'blaze/scss/components.cards.scss';
import { uWindowBoxLarge } from 'blaze/scss/utilities.boxing.scss';
import { cHeading } from 'blaze/scss/components.headings.scss';
import {
  secondOpinionCard as card,
  secondOpinionCardHeader as headerCls,
  secondOpinionCardCloseIcon as closeIconCls,
  secondOpinionCardTextarea as textAreaCls,
  secondOpinionCardHeading as headingCls,
} from './SecondOpinionCard.scss';
import { CloseIcon, SubmitButton, ObservationButton } from '../../Common';

export default class SecondOpinionCard extends React.PureComponent {
  static propTypes = {
    reason: PropTypes.string,
    observations: PropTypes.instanceOf(Array),
    onReasonChange: PropTypes.func.isRequired,
    onObserve: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    reason: '',
  };

  handleObserve = code => this.props.onObserve(code);

  handleChange = e => {
    this.props.onReasonChange(e.currentTarget.value);
  };

  renderButtons(observations, handler) {
    const buttons = observations.map((ob, index) => {
      const { name, observation_type_code } = ob;

      return (
        <ObservationButton
          key={observation_type_code}
          name={name}
          existing={ob.isSelected()}
          observation_type_code={observation_type_code}
          onClick={handler}
        />
      );
    });

    return buttons;
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown = e => {
    if (e.keyCode === 27 && e.defaultPrevented === false) {
      // amazing, the absence of these breaks youtube embeds
      e.preventDefault();
      e.stopPropagation();
      this.props.onClose();
    }
  };

  render() {
    return (
      <div className={card}>
        <div className={`${cCard} ${uWindowBoxLarge}`}>
          <header className={headerCls}>
            <div>
              <h1 className={headingCls}>Get A Second Opinion</h1>
              <span className="f4 gray">
                Tell us why you’d like to get a second opinion on this piece of
                content.
              </span>
            </div>
            <div>
              <button onClick={this.props.onClose}>
                <CloseIcon className={closeIconCls} />
              </button>
            </div>
          </header>
          <div className={cCardBody}>
            <h3 className={`${cHeading} brandon f4 db fw6`}>
              What did you observe?
            </h3>
            {this.renderButtons(this.props.observations, this.handleObserve)}
            <label
              htmlFor="second-opinion-reason"
              className={`${cHeading} brandon f4 db fw6`}
            >
              Why are you unsure?
            </label>
            <textarea
              id="second-opinion-reason"
              className={textAreaCls}
              value={this.props.reason}
              onChange={this.handleChange}
              autoFocus
            />
          </div>
          <div className={cCardFooter}>
            <SubmitButton
              label="Request 2nd Opinion"
              onClick={this.props.onSubmit}
              style={{
                width: 'auto',
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ModerationCard/PowerReviewsModerationCard/SecondOpinionCard.js